import React from 'react';

export interface StatusBadgeProps {
  status: string;
}

export default function StatusBadge({ status }: StatusBadgeProps): React.JSX.Element {
  const styles: Record<string, { bg: string; color: string; dot: string }> = {
    active:    { bg: "rgba(37, 211, 102, 0.12)",  color: "#25D366", dot: "#25D366" },
    paused:    { bg: "rgba(255, 181, 71, 0.12)",   color: "#FFB547", dot: "#FFB547" },
    training:  { bg: "rgba(167, 139, 250, 0.12)",  color: "#A78BFA", dot: "#A78BFA" },
    completed: { bg: "rgba(77, 166, 255, 0.12)",   color: "#4DA6FF", dot: "#4DA6FF" },
    scheduled: { bg: "rgba(136, 136, 160, 0.12)",  color: "#8888A0", dot: "#8888A0" },
  };
  const s = styles[status] ?? styles.active;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium capitalize"
      style={{ background: s.bg, color: s.color }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full flex-shrink-0"
        style={{
          background: s.dot,
          boxShadow: status === "active" ? `0 0 8px ${s.dot}` : "none",
        }}
      />
      {status}
    </span>
  );
}
